import React from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { observer, Provider } from "mobx-react";
import { Spinner, Card, Elevation, Icon, Tooltip, Position } from "@blueprintjs/core";
import Flexbox from "flexbox-react";
import ScrollableDropdown from "../components/shared/ScrollableDropdown.jsx";
import PageHeading from "../components/goals/PageHeading.js";
import Utilities from "../utils/Utilities.js";
import { inject } from "mobx-react";
import { NonIdealState } from "@blueprintjs/core";
import { Button, Classes, Collapse, MenuItem } from "@blueprintjs/core";
import ThemeWrapper from "../components/styles/ThemeWrapper/index.js";
import LayoutHeader from "../components/layout/LayoutHeader";
import ToastStore from "../stores/ToastStore";
import ErrorBoundary from "../components/errors/ErrorBoundary";
import '../components/goal_performance/MyAssessmentView.css';
import CurrentUserStore from "../stores/CurrentUserStore.js";
import PerformanceTabSelector from "../components/goal_performance/PerformanceTabSelector";
import EmptyStateNotice from "../components/goal_performance/EmptyStateNotice.js";
import ReviewSectionRenderer from "../components/goal_performance/ReviewSectionRenderer.js";
import { allowedExtensions } from "../static/Constant.js";


@observer
class TeamReviewView extends React.Component {
  state = {
    isLoading: false,
    goalCycleList: [],
    employeeList: [],
    selectedTimeframe: {},
    selectedEmployee: {},
    selectedEmployeeName: "",
    performanceSteps: [],
    selectedStep: null,
    reviewData: [],
    reviewMode: "form",
    goalData: [],
    subGoalsByGoalId: {},
    openSubGoals: {},
    acknowledgementMode: false,
    acknowledgementData: null,
    averageGoalRating: 0,
    averageReviewRating: 0,
    managerGlobalfinalRating: 0,
    managerGlobalfinalRatingLabel: "",
    averageGoalRatingLabel: "",
    averageReviewRatingLabel: "",

    answers: {},
    ratings: {},
    commentAnswers: {},
    goalRatings: {},
    categoryWiseRatings: {},

    submissionStatus: 0,

    initialUserId: null,
    initialGoalSettingId: null,
    managerUserId: null,
    check_in: [],
    selectedCheckIn: null,
    isLoadingCheckIn: false,
  };
  /* URL / SESSION SELECTIONS */

  getUrlSelections = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const encoded = params.get("r");
      if (!encoded) return null;
      const decoded = JSON.parse(atob(decodeURIComponent(encoded)));

      return {
        userId: decoded.u,
        goalSettingId: decoded.g,
        managerUserId: decoded.m,
        userName: decoded.n,
        checkinId: decoded.c
      };
    } catch (e) {
      console.error("Error decoding URL parameter", e);
      return null;
    }
  };

  getSessionSelections = () => {
    try {
      const raw = sessionStorage.getItem("team_review_context");
      if (!raw) return null;
      const parsed = JSON.parse(raw);

      return {
        userId: parsed.u,
        goalSettingId: parsed.g,
        managerUserId: parsed.m,
        userName: parsed.n,
        checkinId: parsed.c
      };
    } catch (e) {
      console.error("Error reading sessionStorage", e);
      return null;
    }
  };

  applySelections = () => {
    const { initialUserId, initialGoalSettingId, goalCycleList, employeeList, selectedEmployeeName } = this.state;

    let updates = {};
    const cycle = goalCycleList.find(
      g => String(g.id) === String(initialGoalSettingId)
    );
    if (cycle) {
      updates.selectedTimeframe = cycle;
    }

    let employee = employeeList.find(
      e => String(e.id) === String(initialUserId)
    );

    if (employee) {
      updates.selectedEmployee = employee;

      if (!selectedEmployeeName) {
        updates.selectedEmployeeName =
          employee.fullName ||
          `${employee.first_name || ""} ${employee.last_name || ""}`.trim();
      }
    } else {
      updates.selectedEmployee = { id: initialUserId };
    }

    this.setState(
      {
        ...updates,
        check_in: [],
        selectedCheckIn: null
      },
      async () => {
        await this.handleCheckIn(false);
        await this.fetchPerformanceSteps(false);
        this.setState({ isLoading: false });
      }
    );
  };

  /*      COMPONENT MOUNT     */

  componentDidMount() {
    let selectionData = this.getUrlSelections();
    if (!selectionData) {
      selectionData = this.getSessionSelections();
    }
    if (
      !selectionData ||
      !selectionData.userId ||
      !selectionData.goalSettingId
    ) {
      Utilities.navigate("/reports/team_performance");
      return;
    }

    sessionStorage.setItem(
      "team_review_context",
      JSON.stringify({
        u: selectionData.userId,
        g: selectionData.goalSettingId,
        m: selectionData.managerUserId,
        n: selectionData.userName,
        c: selectionData.checkinId
      })
    );

    this.setState(
      {
        initialUserId: selectionData.userId,
        initialGoalSettingId: selectionData.goalSettingId,
        initialCheckInId: selectionData.checkinId,
        selectedEmployeeName: selectionData.userName || "Employee",
        managerUserId: selectionData.managerUserId || CurrentUserStore.currentUser.id,
        isLoading: true
      },
      () => {
        Promise.all([
          this.getAllGoalCycleList(false),
          // this.getSubordinatesEmployeeList()
        ])
          .then(() => {
            this.applySelections();
          })
          .catch(err => {
            console.error(err);
            this.setState({ isLoading: false });
          });
      }
    );
  }

  /*      API FUNCTIONS      */
  getAllGoalCycleList = (showLoader = true) => {
    if (showLoader) this.setState({ isLoading: true });

    return new Promise((resolve, reject) => {
      axios.get(`${Cookies.get("apiEnv")}/goal_settings/goal_cycle_list`)
        .then(response => {
          const goalCycleList = response.data;

          if (goalCycleList.length > 0) {
            this.setState(
              {
                goalCycleList,
                selectedTimeframe: goalCycleList[0],
                ...(showLoader ? { isLoading: false } : {})
              },
              resolve
            );
          } else {
            this.setState({
              goalCycleList: [],
              selectedTimeframe: {},
              ...(showLoader ? { isLoading: false } : {})
            }, resolve);
          }
        })
        .catch(error => {
          if (showLoader) {
            this.setState({
              error: "Failed to load",
              isLoading: false
            });
          }
          reject(error);
        });
    });
  };

  getSubordinatesEmployeeList = async () => {
    const response = await axios
      .get(`${Cookies.get("apiEnv")}/users/subordinates`);
    this.setState({
      employeeList: response.data || []
    });
  };

  fetchPerformanceSteps = async (showLoader = true) => {
    const { selectedTimeframe, selectedEmployee, selectedCheckIn } = this.state;

    if (!selectedTimeframe?.id) return;
    if (showLoader) this.setState({ isLoading: true });
    try {
      const params = {
        goal_setting_id: selectedTimeframe.id
      };

      if (selectedEmployee?.id) {
        params.user_id = selectedEmployee.id;
      }

      if (selectedCheckIn?.id) {
        params.checkin_id = selectedCheckIn.id;
      }
      const response = await axios.get(
        `${Cookies.get("apiEnv")}/performance_steps`,
        {
          params
        }
      );

      const steps = response.data || [];
      return new Promise((resolve) => {
        this.setState(
          {
            performanceSteps: steps,
            selectedStep: steps[0] || null
          },
          async () => {
            if (steps.length > 0) {
              await this.fetchReviewQuestions(steps[0], showLoader);
            } else {
              if (showLoader) this.setState({ isLoading: false });
            }
            resolve();
          }
        );
      });
    } catch (error) {
      console.error(error);

      if (showLoader) {
        this.setState({
          isLoading: false
        });
      }
    }
  };

  fetchReviewQuestions = async (step, showLoader = true) => {
    const { selectedTimeframe, selectedEmployee, selectedCategory, selectedCheckIn } = this.state;
    if (showLoader) {
      this.setState({ isLoading: true, selectedStep: step });
    } else {
      this.setState({ selectedStep: step });
    }
    try {
      const response = await axios.post(
        `${Cookies.get("apiEnv")}/review_questions/questions_with_answers`,
        {
          goal_setting_id: selectedTimeframe.id,
          review_process_step_id: step.id,
          user_id: selectedEmployee.id,

          ...(selectedCategory?.id && {
            question_category_id: selectedCategory.id
          }),

          ...(selectedCheckIn?.id && {
            checkin_id: selectedCheckIn.id
          })
        }
      );
      const result = response.data;
      const isAcknowledgementMode =
        step?.step_type === 2 &&
        (!result?.data ||
          result.data.every(
            cat => !cat.questions || cat.questions.length === 0
          ));
      let reviewMode = this.getReviewMode(step, result.status);
      if (isAcknowledgementMode) {
        reviewMode = "acknowledgement";
      }
      const answers = {};
      const ratings = {};
      const commentAnswers = {};
      const goalRatings = {};

      // QUESTIONS
      (result.data || []).forEach(category => {
        (category.questions || []).forEach(question => {
          if (question.question_type === "Files") {
            answers[question.id] = {
              answer_type: question.answer_type || "Files",
              answer: question.answer || "",
              answer_file: null,
              file_url: question.file_url || ""
            };
          } else if (question.question_type === "Checkbox") {
            let parsedAnswer = {};

            try {
              if (question.answer) {
                parsedAnswer = JSON.parse(
                  question.answer.replace(/=>/g, ":")
                );
              }
            } catch (e) {
              console.error("Checkbox parse error", e);
            }
            answers[question.id] = parsedAnswer;
          }
          else {
            answers[question.id] = question.answer || "";
          }
          ratings[question.id] =
            question.rating || "";
        });

        // COMMENT QUESTIONS
        (category.comment_questions || []).forEach(
          comment => {
            commentAnswers[comment.id] =
              comment.answer || "";
          }
        );
      });
      // GOALS
      (result.goals || []).forEach(goal => {
        goalRatings[goal.id] =
          goal.goal_score || "";
      });

      return new Promise((resolve) => {
        this.setState({
          reviewData: result.data || [],
          goalData: result.goals || [],
          acknowledgementMode: isAcknowledgementMode,
          acknowledgementData: result.acknowledged_data || null,
          reviewMode,
          averageGoalRating: result.average_goal_rating || 0,
          averageGoalRatingLabel: result?.average_goal_rating_label || "",
          averageReviewRating: result.average_question_rating || 0,
          averageReviewRatingLabel: result.average_question_rating_label || "",
          managerGlobalfinalRating: result.final_rating?.final_rating ?? 0,
          managerGlobalfinalRatingLabel: result.final_rating?.final_rating_label ?? "",
          answers,
          ratings,
          commentAnswers,
          goalRatings,
          submissionStatus: result.status,
          ...(showLoader ? { isLoading: false } : {})
        },
          async () => {
            await this.fetchSubGoalsForAllGoals(
              result.goals || [],
              this.state.managerUserId
            );
            resolve();
          }
        );
      });
    } catch (error) {
      console.error(error);

      if (showLoader) {
        this.setState({
          isLoading: false
        });
      }
    }
  };
  getSubGoalListParams = (goalId, managerId = null) => {
    const { selectedTimeframe, selectedEmployee } = this.state;
    const params = {
      goal_setting_id: selectedTimeframe.id,
      goal_id: goalId,
      user_id: selectedEmployee.id
    };

    if (managerId) params.manager_id = managerId;
    return params;
  };

  toggleSubGoals = (goalId) => {
    this.setState(prev => ({
      openSubGoals: {
        ...prev.openSubGoals,
        [goalId]: !prev.openSubGoals[goalId]
      }
    }));
  };


  fetchSubGoalsForAllGoals = async (goalList = [], managerId = null) => {
    try {
      const entries = await Promise.all(goalList.map(async goal => {
        if (Array.isArray(goal.sub_goals)) return [goal.id, goal.sub_goals];
        const response = await axios.get(`${Cookies.get("apiEnv")}/sub_goals`, {
          params: this.getSubGoalListParams(goal.id, managerId)
        });
        const data = response.data;
        return [goal.id, Array.isArray(data) ? data : (Array.isArray(data?.sub_goals) ? data.sub_goals : [])];
      }));
      const subGoalsByGoalId = {};
      entries.forEach(([id, children]) => { subGoalsByGoalId[id] = children; });
      this.setState({ subGoalsByGoalId, openSubGoals: {} });
    } catch (error) {
      console.error("Subgoal fetch failed", error);
    }
  };


  /*     REVIEW MODE       */

  getReviewMode = (step, status) => {
    if (!step) { return "readOnly"; }
    // SELF ASSESSMENT
    if (step.step_type === 0) {
      if (status === 2) {
        return "readOnly";
      }
      return "empty";
    }
    // REVIEW
    if (step.step_type === 1) {
      if (status === 0) return "form";
      if (status === 1) return "draft";
      if (status === 2) return "readOnly";
    }
    // OTHER
    if (step.step_type === 2) {
      /*  assign_type  0 -> readonly 1,2 -> status based */
      if (step.assign_type === 0) {
        if (status === 0) return "empty";
        if (status === 1) return "empty";
        if (status === 2) return "readOnly";
      }
      if (
        step.assign_type === 1 ||
        step.assign_type === 2
      ) {
        if (status === 0) return "form";
        if (status === 1) return "draft";
        if (status === 2) return "readOnly";
      }
    }
    return "readOnly";
  };

  /*      FORM HANDLERS      */
  handleAnswerChange = (questionId, value) => {
    this.setState(prev => ({
      answers: { ...prev.answers, [questionId]: value }
    }));
  };

  handleCommentChange = (commentId, value) => {
    this.setState(prev => ({
      commentAnswers: { ...prev.commentAnswers, [commentId]: value }
    }));
  };

  /*    SUBMIT   */
  validateStepSubmissionAccess = selectedStep => {
    const currentUserId = CurrentUserStore.currentUser.id;
    const currentUserJobProfileId = CurrentUserStore.currentUser?.job_profile?.id;
    // No restriction
    if (
      !selectedStep?.assign_type ||
      !Array.isArray(selectedStep?.assignee_list)
    ) {
      return true;
    }
    // JOB PROFILE BASED ACCESS
    if (selectedStep.assign_type === 1) {
      const allowedJobProfiles =
        selectedStep.assignee_list.map(String);

      return allowedJobProfiles.includes(
        String(currentUserJobProfileId)
      );
    }
    // EMPLOYEE BASED ACCESS
    if (selectedStep.assign_type === 2) {
      const allowedEmployees = selectedStep.assignee_list.map(String);
      return allowedEmployees.includes(
        String(currentUserId)
      );
    }
    return true;
  };

  handleAcknowledge = async () => {
    try {
      const {
        selectedTimeframe,
        selectedEmployee,
        selectedStep
      } = this.state;

      this.setState({ isLoading: true });
      const payload = {
        goal_setting_id: selectedTimeframe.id,
        review_process_step_id: selectedStep.id,
        user_id: selectedEmployee.id,
        acknowledged_by: CurrentUserStore.currentUser.id
      };
      await axios.post(`${Cookies.get("apiEnv")}/performance_steps/acknowledge`, payload);
      ToastStore.showToast("Acknowledged successfully", "success");
      this.fetchReviewQuestions(selectedStep);
    } catch (error) {
      console.error(error);

      ToastStore.showToast("Failed to acknowledge", "danger");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleSubmit = async status => {
    const {
      selectedTimeframe,
      selectedEmployee,
      selectedStep,
      reviewData,
      goalData,
      answers,
      ratings,
      commentAnswers,
      goalRatings,
      averageGoalRating,
      averageReviewRating,
      selectedCheckIn
    } = this.state;

    try {

      /* STEP ACCESS VALIDATION      */
      const hasNormalAccess = this.validateStepSubmissionAccess(selectedStep);

      // only allow future-step editors if review is already published
      const hasPreviousEditAccess = selectedStep?.is_submitted && this.canEditReviewStep(selectedStep);
      if (!hasNormalAccess && !hasPreviousEditAccess) {
        ToastStore.showToast(
          "You are not allowed to submit this review.", "error"
        );
        return;
      }

      /* PAYLOAD   */
      const payload = {
        goal_setting_id: selectedTimeframe.id,
        review_process_step_id: selectedStep.id,
        user_id: selectedEmployee.id,
        submitted_by: CurrentUserStore.currentUser.id,
        average_goal_rating: averageGoalRating,
        average_review_rating: averageReviewRating,
        ...(selectedCheckIn?.id && {
          checkin_id: selectedCheckIn.id
        }),

        // final_rating:
        //   finalRating,

        // final_rating_label:
        //   finalRatingLabel,
        status,
        goals: (goalData || []).map(goal => ({
          goal_id: goal.id,
          goal_rating:
            goalRatings[goal.id]
        })),
        answers: [],
        remark_answers: []
      };

      /* QUESTIONS   */
      (reviewData || []).forEach(category => {
        (category.questions || []).forEach(
          question => {
            const answerValue = answers[question.id];
            payload.answers.push({
              review_question_id: question.id,
              answer_type: question.question_type,
              answer: answerValue?.answer || answerValue,
              answer_file:
                typeof answerValue === "object"
                  ? answerValue?.answer_file || null
                  : null,
              file_url: typeof answerValue === "object"
                ? answerValue?.file_url || ""
                : "",
              rating: ratings[question.id]
            });
          }
        );

        /* COMMENTS   */
        (
          category.comment_questions || []
        ).forEach(comment => {
          payload.remark_answers.push({
            category_comment_question_id: comment.id,
            category_comment_answer: commentAnswers[comment.id]
          });
        });
      });

      /* CHECK IF FILE EXISTS           */
      const hasFile = payload.answers.some(
        answer =>
          answer.answer_type === "Files" &&
          answers[
            answer.review_question_id
          ]?.answer_file
      );

      /* FILE API CALL    */

      this.setState({ isLoading: true });
      if (hasFile) {
        const formData = new FormData();
        formData.append(
          "payload",
          JSON.stringify(payload)
        );
        payload.answers.forEach(answer => {
          const file =
            answers[answer.review_question_id]?.answer_file;
          if (file) {
            formData.append(`files[${answer.review_question_id}]`, file);
          }
        });
        

        await axios.post(
          `${Cookies.get("apiEnv")}/review_questions/review_submissions`,
          formData,
          {
            headers: {
              "Content-Type":
                "multipart/form-data"
            }
          }
        ).then(response => {
          this.setState({ isLoading: false });
          this.fetchReviewQuestions(
            selectedStep
          );
        })
      }
      /* NORMAL API CALL   */
      else {

        await axios.post(
          `${Cookies.get("apiEnv")}/review_questions/review_submissions`,
          payload
        ).then(response => {
          this.setState({ isLoading: false });
          this.fetchReviewQuestions(
            selectedStep
          );
        })
      }
      this.setState({ isLoading: false });

      /* SUCCESS   */
      ToastStore.showToast(
        status === 2
          ? "Review submitted successfully"
          : "Draft saved successfully",
        "success"
      );
    } catch (error) {
      console.error(error);
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";
      ToastStore.showToast(errorMessage, "danger");
      this.setState({ isLoading: false });
    }
  };
  /*  RATING HELPERS  */
  getRatingLabel = (rating, labels = []) => {
    if (
      rating == null ||
      rating === "" ||
      Number.isNaN(Number(rating))
    ) {
      return "";
    }
    const matched = labels.find(label => {
      const start = Number(label.start_value);
      const end = Number(label.end_value);
      return (
        Number(rating) >= start &&
        Number(rating) <= end
      );
    });
    return matched?.label || "";
  };


  /*   ASSESSMENT PAYLOAD BUILDER    */
  buildAssessmentRatingPayload = () => {
    const { reviewData, ratings, selectedTimeframe } = this.state;
    const isWeightAllowed = selectedTimeframe?.is_weight_allow;
    const allRatings = [];

    (reviewData || []).forEach(category => {
      (category.questions || []).forEach(question => {
        const ratingValue = ratings[question.id];
        const normalizedRating = ratingValue === "" || ratingValue == null ? -1 : Number(ratingValue);
        allRatings.push(
          isWeightAllowed
            ? {
              rating: normalizedRating,
              weightage: Number(question.weightage || 0)
            }
            : {
              rating: normalizedRating
            }
        );
      });
    });

    return {
      ratings: allRatings,
      no_of_goals: allRatings.length
    };
  };

  buildCategoryWisePayload = () => {
    const { reviewData, ratings, selectedTimeframe } = this.state;
    const isWeightAllowed = selectedTimeframe?.is_weight_allow;

    const categories = (reviewData || []).map(category => {
      const categoryId = category.category_id &&
        category.category_id !== "null"
        ? category.category_id
        : "uncategorized";
      const categoryRatings = (category.questions || []).map(question => {
        const ratingValue = ratings[question.id];
        const normalizedRating = ratingValue === "" ||
          ratingValue == null ? -1 : Number(ratingValue);
        return isWeightAllowed
          ? {
            rating: normalizedRating,
            weightage: Number(question.weightage || 0)
          }
          : {
            rating: normalizedRating
          };
      });
      return {
        category_id: categoryId,
        ratings: categoryRatings
      };

    });

    return { categories };
  };

  buildGoalRatingPayload = () => {

    const { goalData, goalRatings, selectedTimeframe } = this.state;
    const isWeightAllowed = selectedTimeframe?.is_weight_allow;

    const ratingsPayload =
      (goalData || []).map(goal => {

        const ratingValue = goalRatings[goal.id];
        const normalizedRating =
          ratingValue === "" ||
            ratingValue == null
            ? -1
            : Number(ratingValue);

        return isWeightAllowed
          ? {
            rating: normalizedRating,
            weightage: Number(
              goal.goal_weight || 0
            )
          }
          : {
            rating: normalizedRating
          };
      });

    return {
      ratings: ratingsPayload,
      no_of_goals: ratingsPayload.length
    };
  };

  calculateAssessmentRating = async () => {
    try {
      const payload = this.buildAssessmentRatingPayload();
      if (!payload.ratings?.length) {
        return;
      }
      const response = await axios.post(
        `${Cookies.get("apiEnv")}/assessments/rating_calculation`,
        payload
      );
      const finalRating = response.data?.final_rating || 0;
      const finalLabel = this.getRatingLabel(
        finalRating,
        this.state.selectedTimeframe?.rating_labels || []
      );

      this.setState({
        averageReviewRating: finalRating,
        averageReviewRatingLabel: finalLabel
      });

    } catch (error) {
      console.error(error);
      ToastStore.showToast("Failed to calculate assessment rating", "danger");
    }
  };

  calculateCategoryWiseAssessmentRating = async () => {
    try {
      const payload = this.buildCategoryWisePayload();
      if (!payload.categories?.length) {
        return;
      }
      const response = await axios.post(
        `${Cookies.get("apiEnv")}/assessments/ratings_by_category`,
        payload
      );
      const categoryWiseRatings = {};
      (response.data?.categories || []).forEach(cat => {
        categoryWiseRatings[cat.category_id] = {
          avg: cat.average_rating,
          naCount: cat.na_count,
          label: cat.average_rating_label
        };
      });

      this.setState({ categoryWiseRatings });

    } catch (error) {

      console.error(error);
      ToastStore.showToast(
        "Category rating calculation failed",
        "danger"
      );
    }
  };


  /*   GOAL RATING API   */


  calculateGoalRating = async () => {
    try {
      const payload = this.buildGoalRatingPayload();
      if (!payload.ratings?.length) {
        return;
      }
      const response = await axios.post(`${Cookies.get("apiEnv")}/assessments/rating_calculation`,
        payload
      );
      const finalRating = response.data?.final_rating || 0;
      const finalLabel =
        this.getRatingLabel(
          finalRating,
          this.state.selectedTimeframe?.rating_labels || []
        );

      this.setState({
        averageGoalRating: finalRating,
        averageGoalRatingLabel: finalLabel
      });

    } catch (error) {
      console.error(error);
      ToastStore.showToast(
        "Failed to calculate goal rating",
        "danger"
      );
    }
  };

  /*  RATING CHANGE HANDLER   */
  handleRatingChange = (
    questionId,
    value
  ) => {

    this.setState(prev => ({
      ratings: {
        ...prev.ratings,
        [questionId]: value
      }
    }), () => {
      this.calculateAssessmentRating();
      this.calculateCategoryWiseAssessmentRating();
    });

  };

  /*  GOAL RATING CHANGE    */
  handleGoalRatingChange = (
    goalId,
    value
  ) => {

    this.setState(prev => ({
      goalRatings: {
        ...prev.goalRatings,
        [goalId]: value
      }
    }), () => {
      this.calculateGoalRating();
    });

  };

  handleSelectTimeframe = timeframe => {
    this.setState(
      {
        selectedTimeframe: timeframe,
        check_in: [],
        selectedCheckIn: null,
        isLoading: true
      },
      async () => {
        await this.handleCheckIn(false);
        await this.fetchPerformanceSteps(false);
        this.setState({ isLoading: false });
      }
    );
  };

  handleSelectCheckIn = checkIn => {
    if (checkIn.current_state === 2) {
      return;
    }

    this.setState(
      {
        selectedCheckIn: checkIn
      },
      () => {
        if (this.state.selectedStep) {
          this.fetchReviewQuestions(this.state.selectedStep);
        }
      }
    );
  };

  handleCheckIn = async (showLoader = true) => {
    const { selectedTimeframe, selectedCheckIn, initialCheckInId } = this.state;

    if (!selectedTimeframe?.id) return;

    try {
      if (showLoader) this.setState({ isLoadingCheckIn: true });

      const res = await axios.get(
        `${Cookies.get("apiEnv")}/onboarding_steps/checkins_by_cycle`,
        {
          params: {
            goal_cycle_id: selectedTimeframe.id
          }
        }
      );

      const list = Array.isArray(res.data) ? res.data : [];

      let selected = null;

      if (initialCheckInId) {
        selected = list.find(item => String(item.id) === String(initialCheckInId)) || null;
      }

      // Preserve previous selection only if not future
      if (!selected && selectedCheckIn?.id) {
        selected =
          list.find(
            item =>
              item.id === selectedCheckIn.id &&
              item.current_state !== 2
          ) || null;
      }

      // Auto select current
      if (!selected) {
        selected =
          list.find(item => item.current_state === 1) ||

          // fallback -> latest available past
          list.find(item => item.current_state === 0) ||

          null;
      }

      this.setState({
        check_in: list,
        selectedCheckIn: selected,
        initialCheckInId: null,
        ...(showLoader ? { isLoadingCheckIn: false } : {})
      });

    } catch (e) {
      ToastStore.showToast("Failed to load Check-In", "danger");
    } finally {
      if (showLoader) {
        this.setState({
          isLoadingCheckIn: false
        });
      }
    }
  };

  handleStepClick = step => {
    this.fetchReviewQuestions(step);
  };

  handleBack = () => {
    Utilities.navigate("/reports/team_performance");
  };

  handleFileUpload = (question, file = null) => {
    const MAX_SIZE = 15 * 1024 * 1024;

    const extension = file?.name
      ?.split(".")
      ?.pop()
      ?.toLowerCase();

    if (
      file &&
      (
        file.size > MAX_SIZE ||
        !allowedExtensions.includes(extension)
      )
    ) {
      ToastStore.showToast(
        "File size should not exceed 10MB and allowed file are PDF, Word, Document, Excel, Image, PowerPoint",
        "danger"
      );
      return;
    }

    // Get the existing file_url to preserve previously uploaded files
    const existingAnswer = this.state.answers[question.id] || {};
    const previousFileUrl = existingAnswer?.file_url || "";

    this.handleAnswerChange(question.id, {
      answer_type: question.question_type,
      answer: file ? file.name : "",
      answer_file: file || null,
      file_url: previousFileUrl
    });
  };

  /*  RENDER   */


  getPerformanceTabs = () => {
    const { performanceSteps } = this.state;
    if (!Array.isArray(performanceSteps)) {
      return [];
    }
    return performanceSteps.map(step => ({
      key: step.id,
      label: step.step_name,
      type: this.getStepTabType(step)
    }));
  };

  getStepTabType = step => {
    if (step.step_type === 0) {
      return "assessment";
    }

    if (step.step_type === 1) {
      return "review";
    }

    return "review";
  };

  isStepContentUnlocked = step => {
    const { performanceSteps } = this.state;
    if (!step || !Array.isArray(performanceSteps)) return false;
    if (step.step_type === 0) return true;

    const stepIndex = performanceSteps.findIndex(
      current => current.id === step.id
    );

    if (stepIndex <= 0) return true;

    return performanceSteps
      .slice(0, stepIndex)
      .every(prevStep => Boolean(prevStep.is_submitted));
  };

  handleTabChange = stepId => {
    const { performanceSteps } = this.state;
    const selectedStep = performanceSteps.find(
      step => step.id === stepId
    );
    if (!selectedStep) return;
    if (!this.isStepContentUnlocked(selectedStep)) {
      this.setState({
        selectedStep,
        reviewMode: "locked",
        reviewData: [],
        goalData: []
      });
      return;
    }
    this.setState(
      {
        selectedStep
      },
      () => {
        if (selectedStep) {
          this.fetchReviewQuestions(selectedStep);
        }
      }
    );
  };



  canEditReviewStep = (stepToEdit) => {

    const { performanceSteps } = this.state;
    const currentUserId = String(CurrentUserStore.currentUser.id);
    const currentUserJobProfileId = String(CurrentUserStore.currentUser?.job_profile?.id);

    if (!stepToEdit || !Array.isArray(performanceSteps)) {
      return false;
    }

    // only published review steps editable
    if (
      Number(stepToEdit.step_type) !== 1 ||
      !stepToEdit.is_submitted
    ) {
      return false;
    }

    const currentIndex = performanceSteps.findIndex(
      step => step.id === stepToEdit.id
    );
    if (currentIndex === -1) {
      return false;
    }

    // ONLY FUTURE STEPS
    const futureSteps = performanceSteps.slice(
      currentIndex + 1
    );

    for (const step of futureSteps) {
      // must allow editing
      if (
        Number(step.allow_previous_step_editing) !== 1
      ) {
        continue;
      }

      const assigneeList = (step.assignee_list || []).map(String);
      // JOB PROFILE ACCESS
      if (Number(step.assign_type) === 1) {
        if (
          assigneeList.includes(
            currentUserJobProfileId
          )
        ) {
          return true;
        }
      }

      // EMPLOYEE ACCESS
      if (Number(step.assign_type) === 2) {
        if (
          assigneeList.includes(
            currentUserId
          )
        ) {
          return true;
        }
      }
    }
    return false;
  };


  handleEditReviewStep = (step) => {
    this.setState({
      reviewMode: "form"
    });
  };

  render() {
    const stores = {
      ToastStore
    };

    const {
      isLoading,
      selectedTimeframe,
      goalCycleList,
      selectedEmployeeName,

      selectedStep,

      reviewData,
      reviewMode,
      goalData,
      subGoalsByGoalId,
      openSubGoals,
      managerGlobalfinalRating,
      managerGlobalfinalRatingLabel,
      answers,
      ratings,
      commentAnswers,
      goalRatings,
      averageGoalRating,
      averageReviewRating,
      averageGoalRatingLabel,
      averageReviewRatingLabel,
      categoryWiseRatings,
      check_in,
      selectedCheckIn,
      isLoadingCheckIn
    } = this.state;

    const isSelectedStepUnlocked = this.isStepContentUnlocked(selectedStep);
    const effectiveReviewMode =
      selectedStep && !isSelectedStepUnlocked
        ? "locked"
        : reviewMode;

    const filteredGoalCycles = goalCycleList.filter(gc => gc.id !== selectedTimeframe.id);

    return (
      <Provider {...stores}>
        <ThemeWrapper>
          <ErrorBoundary>
            <Flexbox
              flexGrow={1} width="100hw" alignContent="stretch" flexDirection="column" className="push-20-l push-20-r " style={{ marginTop: 20 }}
            >
              {isLoading ? (
                <div>

                  <Flexbox flexGrow={1} flexDirection="column" justifyContent="center" alignItems="center" style={{ marginTop: "230px" }}>
                    <img
                      style={{ height: "35px", width: "35px" }}
                      src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif"
                      alt="Please wait"
                    />
                  </Flexbox>
                </div>
              ) : (
                <>
                  <Flexbox
                    flexDirection="row"
                    alignItems="flex-start"
                    style={{
                      width: "100%",
                      gap: 20,
                    }}
                  >
                    {/* Left */}
                    <Flexbox
                      flexGrow={1}
                      flexShrink={1}
                      alignItems="flex-start"
                      style={{
                        minWidth: 0,
                        gap: 10,
                      }}
                    >
                      <Icon
                        icon="arrow-left"
                        onClick={this.handleBack}
                        style={{
                          cursor: "pointer",
                          marginTop: 8,
                          flexShrink: 0,
                        }}
                      />

                      <div
                        style={{
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        <PageHeading
                          text={`Performance Review — ${selectedEmployeeName}`}
                          description="Review employee performance and feedback."
                        />
                      </div>
                    </Flexbox>

                    {/* Right */}
                    <Flexbox
                      flexShrink={0}
                      alignItems="flex-start"
                      style={{
                        gap: 16,
                      }}
                    >
                      {/* Goal Cycle */}
                      <div
                        style={{
                          width: 250,
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                        }}
                      >
                        <span
                          style={{
                            fontSize: 13,
                            fontWeight: 500,
                            color: "#000",
                          }}
                        >
                          Goal Cycle
                        </span>

                        <ScrollableDropdown
                          width={250}
                          label={selectedTimeframe.title || "Goal Cycle"}
                          items={filteredGoalCycles || []}
                          getKey={g => g.id}
                          getLabel={g => g.title}
                          enableSearch
                          onSelect={this.handleSelectTimeframe}
                        />
                      </div>

                      {/* Check-in */}
                      {selectedTimeframe?.is_checkin_enable === 1 && (
                        <div
                          style={{
                            width: 250,
                            display: "flex",
                            flexDirection: "column",
                            gap: 4,
                          }}
                        >
                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: 500,
                              color: "#000",
                            }}
                          >
                            Check-in
                          </span>

                          <ScrollableDropdown
                            width={250}
                            label={selectedCheckIn?.title || "Select Check-in"}
                            items={check_in}
                            getKey={item => item.id}
                            getLabel={item => item.title}
                            onSelect={this.handleSelectCheckIn}
                            renderItem={item => (
                              <span
                                style={{
                                  opacity: item.current_state === 2 ? 0.4 : 1,
                                  color: item.current_state === 2 ? "#221f1f" : "#222",
                                }}
                              >
                                {item.title}
                              </span>
                            )}
                            isItemDisabled={item => item.current_state === 2}
                          />
                        </div>
                      )}
                    </Flexbox>
                  </Flexbox>

                  <PerformanceTabSelector
                    activeTab={selectedStep?.id}
                    onTabChange={this.handleTabChange}
                    tabs={this.getPerformanceTabs()}
                  />

                  <Flexbox flexDirection="column" style={{ gap: 20 }} className="self-assessment-container" >
                    <ReviewSectionRenderer
                      mode={effectiveReviewMode}
                      selectedStep={selectedStep}
                      reviewData={reviewData}
                      goalData={goalData}
                      subGoalsByGoalId={subGoalsByGoalId}
                      openSubGoals={openSubGoals}
                      toggleSubGoals={this.toggleSubGoals}
                      answers={answers}
                      acknowledgementData={this.state.acknowledgementData}
                      onAcknowledge={this.handleAcknowledge}
                      onFileUpload={this.handleFileUpload}
                      ratings={ratings}
                      canEditReviewStep={this.canEditReviewStep}
                      onEdit={this.handleEditReviewStep}
                      commentAnswers={commentAnswers}
                      goalRatings={goalRatings}
                      selectedTimeframe={selectedTimeframe}
                      managerGlobalfinalRating={managerGlobalfinalRating}
                      managerGlobalfinalRatingLabel={managerGlobalfinalRatingLabel}
                      averageGoalRating={averageGoalRating}
                      averageGoalRatingLabel={averageGoalRatingLabel}
                      categoryWiseRatings={categoryWiseRatings}
                      averageReviewRating={averageReviewRating}
                      averageReviewRatingLabel={averageReviewRatingLabel}
                      onAnswerChange={this.handleAnswerChange}
                      onRatingChange={this.handleRatingChange}
                      onCommentChange={this.handleCommentChange}
                      onGoalRatingChange={this.handleGoalRatingChange}
                      onSaveDraft={() => this.handleSubmit(1)}
                      onSubmit={() => this.handleSubmit(2)}
                      selectedCheckIn={selectedCheckIn}
                    />
                  </Flexbox>

                </>
              )}
            </Flexbox>
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    );
  }
}

export default TeamReviewView;
